// src/components/DevelopmentBanner.js
import React from 'react';
import "./DevelopmentBanner.css";

const DevelopmentBanner = () => {
  const bannerStyle = {
    position: 'fixed',
    top: 80,
    left: 0,
    width: '100%',
    color: 'white',
    textAlign: 'center',
    padding: '10px 20px',
    zIndex: 999,
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
    backdropFilter: 'blur(5px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(-45deg, #6c5ce7, #a393f5, #5d4ddb, #8e7cf3, #7a66e8, #a393f5)',
    backgroundSize: '400% 400%',
    animation: 'gradient-animation 8s ease infinite',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
    borderTop: '1px solid rgba(255, 255, 255, 0.2)'
  };

  const messageStyle = {
    margin: 0,
    // fontSize: '1rem',
    // fontWeight: 500,
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
  };

  // Add keyframes to the document head
  React.useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes gradient-animation {
        0% { background-position: 0% 50%; }
        25% { background-position: 50% 100%; }
        50% { background-position: 100% 50%; }
        75% { background-position: 50% 0%; }
        100% { background-position: 0% 50%; }
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className='development-banner' style={bannerStyle}>
      <p style={messageStyle}>
        🚧 This site is currently under development. Some features may not work as expected. Last updated: April 11, 2025 🚧
      </p>
    </div>
  );
};

export default DevelopmentBanner;